(function () {
  'use strict';

  // Galerie produit — carrousel glissable (swipe) + miniatures synchronisées
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!track || !slides.length) return;

    function setActiveThumb(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-index'), 10) || 0;
        var target = slides[index];
        if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        setActiveThumb(index);
      }, 100);
    });
  });

  // Compte à rebours du bloc d'achat — date de fin fixe configurée par la
  // marchande dans l'éditeur de thème (format "AAAA-MM-JJ HH:MM"), jamais
  // réinitialisée par visiteur : à l'échéance, le bloc affiche "Offre terminée"
  // puis disparaît, sans fausse urgence qui recommence indéfiniment.
  document.querySelectorAll('[data-countdown-timer]').forEach(function (timerEl) {
    var raw = (timerEl.getAttribute('data-countdown-end') || '').trim();
    var match = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!match) { timerEl.hidden = true; return; }

    var endDate = new Date(
      parseInt(match[1], 10),
      parseInt(match[2], 10) - 1,
      parseInt(match[3], 10),
      parseInt(match[4], 10),
      parseInt(match[5], 10)
    );
    var valueEl = timerEl.querySelector('[data-countdown-value]');
    var labelEl = timerEl.querySelector('[data-countdown-label]');
    if (!valueEl) return;

    function render() {
      var diff = endDate.getTime() - Date.now();
      if (diff <= 0) {
        if (labelEl) labelEl.textContent = 'Offre terminée';
        valueEl.textContent = '';
        clearInterval(intervalId);
        return;
      }
      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      var pad = function (n) { return String(n).padStart(2, '0'); };

      if (days > 0) {
        valueEl.textContent = days + 'j ' + pad(hours) + 'h' + pad(minutes) + 'min';
      } else {
        valueEl.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      }
    }

    render();
    var intervalId = setInterval(render, 1000);
  });

  // Menu mobile (hamburger) — bascule le panneau de navigation
  var mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileMenuToggle && mobileNav) {
    mobileMenuToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      mobileMenuToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  // Avis en vidéo — carrousel (flèches précédent/suivant)
  document.querySelectorAll('.cp-video-reviews__track').forEach(function (track) {
    var wrap = track.closest('.cp-video-reviews__wrap');
    if (!wrap) return;
    var prevBtn = wrap.querySelector('[data-video-reviews-prev]');
    var nextBtn = wrap.querySelector('[data-video-reviews-next]');
    var item = track.querySelector('.cp-video-reviews__item');
    var scrollAmount = item ? item.getBoundingClientRect().width + 16 : 240;

    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount, behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: scrollAmount, behavior: 'smooth' }); });
  });

  // Avis en vidéo — chargement différé : la <video> n'est créée qu'au clic
  // (elle dort dans un <template> jusque-là, donc aucune requête vidéo au chargement
  // de la page), puis lecture plein écran (API Fullscreen native, iOS inclus).
  // Note : on extrait le HTML du <template> via une div temporaire plutôt que
  // template.content.cloneNode() — cloner un <video>/<source> depuis le contenu
  // inerte d'un <template> ne déclenche pas le chargement de la source dans
  // certains moteurs (currentSrc reste vide indéfiniment), ce qui rendait la
  // vidéo invisible au clic, notamment sur mobile. Passer par innerHTML sur un
  // conteneur réel force le navigateur à charger la source normalement.
  document.querySelectorAll('[data-video-play]').forEach(function (btn) {
    var template = btn.querySelector('[data-video-template]');
    if (!template) return;

    btn.addEventListener('click', function () {
      var video = btn.querySelector('video');
      if (!video) {
        var poster = btn.querySelector('.cp-video-reviews__poster');
        var wrapper = document.createElement('div');
        wrapper.innerHTML = template.innerHTML;
        video = wrapper.querySelector('video');
        btn.insertBefore(video, poster ? poster.nextSibling : btn.firstChild);
        template.remove();
        if (poster) poster.remove();

        function resetVideo() {
          video.pause();
          video.controls = false;
          video.muted = true;
          video.currentTime = 0;
        }
        document.addEventListener('fullscreenchange', function () {
          if (document.fullscreenElement !== video) resetVideo();
        });
        video.addEventListener('webkitendfullscreen', resetVideo);
      }

      video.muted = false;
      video.controls = true;
      if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
      } else if (video.requestFullscreen) {
        video.requestFullscreen().catch(function () {});
      }
      video.play().catch(function () {});
    });
  });

  // Avis en photo — carrousel multi-cartes (flèches précédent/suivant, comme les avis vidéo)
  document.querySelectorAll('[data-photo-testi-track]').forEach(function (track) {
    var carousel = track.closest('[data-photo-testi-carousel]');
    if (!carousel) return;
    var prevBtn = carousel.querySelector('[data-photo-testi-prev]');
    var nextBtn = carousel.querySelector('[data-photo-testi-next]');
    var slide = track.querySelector('[data-photo-testi-slide]');
    var scrollAmount = slide ? slide.getBoundingClientRect().width + 16 : 300;

    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount, behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: scrollAmount, behavior: 'smooth' }); });
  });

  // Avis clients — grille en cascade (pas de carrousel) : le seul comportement JS
  // restant est le bouton "Voir plus d'avis" qui révèle les cartes cachées.
  document.querySelectorAll('[data-review-show-more]').forEach(function (showMoreBtn) {
    showMoreBtn.addEventListener('click', function () {
      var wrap = showMoreBtn.closest('.container') || document;
      var hidden = wrap.querySelectorAll('[data-review-card].cp-social__card--hidden');
      var step = parseInt(showMoreBtn.getAttribute('data-step'), 10) || hidden.length;
      for (var i = 0; i < Math.min(step, hidden.length); i++) {
        hidden[i].classList.remove('cp-social__card--hidden');
      }
      if (wrap.querySelectorAll('[data-review-card].cp-social__card--hidden').length === 0) {
        showMoreBtn.parentElement.remove();
      }
    });
  });

  // Accordéon FAQ
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('[data-accordion-item]');
      var panel = item.querySelector('[data-accordion-panel]');
      var isOpen = item.getAttribute('data-open') === 'true';

      item.setAttribute('data-open', String(!isOpen));
      trigger.setAttribute('aria-expanded', String(!isOpen));
      panel.style.maxHeight = isOpen ? null : panel.scrollHeight + 'px';
    });
  });

  // Header transparent superposé au hero (mobile) — bascule vers son fond plein
  // dès qu'on a un peu défilé (seuil court, indépendant de la hauteur du hero :
  // évite que le header reste transparent avec l'image qui défile derrière pendant
  // tout le scroll du hero, ce qui donnait une impression de bandeau qui « bouge »).
  // Classe posée en JS (plutôt que body:has(.cp-hero) en CSS) : certains moteurs
  // n'invalident pas correctement le style d'un sélecteur combinant :has() et une
  // classe togglée dynamiquement (.is-scrolled restait bloqué sur son état initial).
  if (document.querySelector('.cp-hero')) {
    document.body.classList.add('has-hero');
  }
  var headerEl = document.querySelector('.cp-header');
  if (headerEl) {
    var headerScrollThreshold = 56;
    var updateHeaderScrolled = function () {
      headerEl.classList.toggle('is-scrolled', window.scrollY > headerScrollThreshold);
    };
    window.addEventListener('scroll', updateHeaderScrolled, { passive: true });
    updateHeaderScrolled();
  }

  // Apparition douce au scroll — le contenu est visible par défaut (voir base.css) ;
  // le JS ne fait que le cacher temporairement pour l'animation, jamais l'inverse.
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('js');
    revealEls.forEach(function (el) { el.setAttribute('data-reveal-pending', ''); });

    var revealObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { revealObserver.observe(el); });

    // Filet de sécurité : si un élément reste caché anormalement longtemps
    // (capture plein-page, onglet en arrière-plan, etc.), on l'affiche quand même.
    setTimeout(function () {
      document.querySelectorAll('.reveal[data-reveal-pending]:not(.is-visible)').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }, 2000);
  }

  // Icône panier du header — l'app Kaching Cart intercepte ce clic et ouvre son
  // propre panier latéral (voir commentaire dans layout/theme.liquid). On bloque
  // juste la navigation par défaut vers /cart, au cas où l'app ne le ferait pas
  // elle-même dans tous les cas.
  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
    });
  });

  // Page panier (/cart) — bouton supprimer par ligne, sans passer par le drawer
  document.querySelectorAll('[data-cart-page-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-line'), 10);
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
        .then(function () { window.location.reload(); })
        .catch(function () { btn.disabled = false; });
    });
  });
})();
